<template>
	<div class="second-wraper">
		<div class="img-row item1" v-if="activeIndex==0">
			<img src="../../static/p2-img1-d.png" />
			<div class="icon-wrapper">
				<span class="icon icon-1" @click="showModal(1)"></span>
				<span class="icon icon-2" @click="showModal(2)"></span>
			</div>
			<div class="aniBtns">
				<img src="../../static/icon6.png" @click="showModal(3)"/>
			</div>
		</div>
		<div class="img-row item2" v-if="activeIndex==1">
			<img src="../../static/p2-img2-d.png" />
			<div class="icon-wrapper">
				<span class="icon icon-1" @click="showModal(1)"></span>
				<span class="icon icon-2" @click="showModal(2)"></span>
			</div>
			<div class="aniBtns">
				<img src="../../static/icon6.png" @click="showModal(3)"/>
			</div>
		</div>
		<div class="img-row item3" v-if="activeIndex==2">
			<img src="../../static/p2-img3-d.png" />
			<div class="icon-wrapper">
				<span class="icon icon-1" @click="showModal(1)"></span>
				<span class="icon icon-2" @click="showModal(2)"></span>
			</div>
			<div class="aniBtns">
				<img src="../../static/icon6.png" @click="showModal(3)"/>
			</div>
		</div>
		<div class="img-row item4" v-if="activeIndex==3">
			<img src="../../static/p2-img4-d.png" />
			<div class="icon-wrapper">
				<span class="icon icon-1" @click="showModal(1)"></span>
				<span class="icon icon-2" @click="showModal(2)"></span>
			</div>
			<div class="aniBtns">
				<img src="../../static/icon6.png" @click="showModal(3)"/>
			</div>
		</div>
		<MaskCom :list="childList" v-if="modalVisible"></MaskCom>
	</div>
	</div>
</template>

<script>
	import MaskCom from '../components/MaskCarousel.vue';
	export default {
		name: 'ProductSecond',
		components: {
			MaskCom
		},
		data() {
			return {
				modalVisible: false,
				activeIndex: 0,
				childList: {}, // 弹出框中需要的数据
				imgList: [{
						id: 1,
						btn1List: [{
							imgSrc: require("../../static/p2-img1-d1-1.png"),
						}, {
							imgSrc: require("../../static/p2-img1-d1-2.png"),
						}, {
							imgSrc: require("../../static/p2-img1-d1-3.png"),
						}],
						btn2List: [{
							imgSrc: require("../../static/p2-img1-d2-1.png"),
						}, {
							imgSrc: require("../../static/p2-img1-d2-2.png"),
						}],
						btn3List: [{
							imgSrc: require("../../static/p2-img1-d3-1.png"),
						}]						
					},
					{
						id: 2,
						btn1List: [{
							imgSrc: require("../../static/p2-img2-d1-1.png"),
						}, {
							imgSrc: require("../../static/p2-img2-d1-2.png"),
						}],
						btn2List: [{
							imgSrc: require("../../static/p2-img2-d2-1.png"),
						}, {
							imgSrc: require("../../static/p2-img2-d2-2.png"),
						}],
						btn3List: [{
							imgSrc: require("../../static/p2-img2-d3-1.png"),
						}]	
					},
					{
						id: 3,
						btn1List: [{
							imgSrc: require("../../static/p2-img3-d1-1.png"),
						}],
						btn2List: [{
							imgSrc: require("../../static/p2-img3-d2-1.png"),
						}, {
							imgSrc: require("../../static/p2-img3-d2-2.png"),
						}],
						btn3List: [{
							imgSrc: require("../../static/p2-img3-d3-1.png"),
						}]
					},
					{
						id: 4,
						btn1List: [{
							imgSrc: require("../../static/p2-img4-d1-1.png"),
						}],
						btn2List: [{
							imgSrc: require("../../static/p2-img4-d2-1.png"),
						}, {
							imgSrc: require("../../static/p2-img4-d2-2.png"),
						}],
						btn3List: [{
							imgSrc: require("../../static/p2-img4-d3-1.png"),
						}]
					}
				],
			}
		},
		methods: {
			showModal(id) {
				this.modalVisible = true;
				// console.log(this.imgList[this.activeIndex])
				if(id == 2){
					this.childList = this.imgList[this.activeIndex].btn2List;
				}else if(id==3){
					this.childList = this.imgList[this.activeIndex].btn3List;
				}else{
					this.childList = this.imgList[this.activeIndex].btn1List;
				}
				//this.childList = id == 1 ? this.childList = this.imgList[this.activeIndex].btn1List : this.imgList[this.activeIndex].btn2List;
			},
			hideModal() {
				this.modalVisible = false;
			}
		},
		mounted() {
			var that = this;
			that.activeIndex = that.$route.params.mid ? that.$route.params.mid : '0';
		}
	}
</script>

<style lang="less" scoped>
	@import '../assets/css/index';

	img {
		display: block;
		width: 100%;
	}

	.content {
		width: 100%;
	}

	.second-wraper {
		.scale(1681, 967);
		.pos-a(0, 0, 4);
	}

	.img-row {
		position: relative;

		.icon-wrapper {
			position: absolute;
			top: 69.3%;
			left: 13.1%;
			z-index: 2;
			.scale(406, 64);
		}

		.aniBtns {
			.scale(225, 63);
			// .scale(289, 81);
			.pos-a(503, 958, 4);
			.animation(fadeIn2, @t: 1.5s, @delay: 0s, @i: infinite, @dur: alternate);
		}

		&.item2 {
			.icon-wrapper {
				top: 64.6%;
				left: 13.2%;
			}
		}
		&.item3 {
			.icon-wrapper {
				top: 65.1%;
				left: 13%;
			}
			.aniBtns{
				top: 400/@r;
			}
		}
		&.item4 {
			.icon-wrapper {
				top: 71.4%;
				left: 13.2%;
			}
			.aniBtns{
				.pos-a(340, 1122, 4);
			}
		}
	}

	.icon {
		.scale(161, 63);
		display: inline-block;
		margin-right: 40/@r;
		background: url('../../static/icon3.png');
		background-size: 719/@r 63/@r;
		background-repeat: no-repeat;
		overflow: hidden;

		&:last-child {
			margin-right: 0;
		}
	}

	.icon.icon-1 {
		background-position: 0 0;

		&:hover {
			.scale(161, 63);
			background-position: -368/@r 0;
		}
	}

	.icon.icon-2 {
		background-position: -191/@r 0;

		&:hover {
			.scale(161, 63);
			background-position: -559/@r 0;
		}
	}



	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100
	}
</style>
